import Grid from '@mui/material/Grid';
import Layout from '../../../componentsv2/Layout';
import Skeleton from '../../../componentsv2/Skeleton';

export default function InvoicingProductsSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Skeleton width="180px" height="36px" />
          <Skeleton width="140px" height="44px" />
        </Grid>
        <Grid item xs={12}>
          <Skeleton width="100%" height={400} />
        </Grid>
      </Grid>
    </Layout>
  );
}
